import stagingConfig from "../config/staging.json";
import productionConfig from "../config/production.json";

/**
 * Gen-AI image models the 3D scene editor can render a final image through.
 * Lives in `config/{staging,production}.json` (next to every other
 * environment-specific value — see config.ts) rather than here directly,
 * since prod uses different AiModel documents/ids than staging.
 *
 * Some models take aspect ratio and resolution as two independent props
 * (Nano Banana 2); others take a single combined prop (Seedream, whose
 * `image_size` enum already bundles both). `camera_presets` normalizes both
 * shapes into one list per model: each preset carries a readable `aspect`
 * (for the camera's aspect dropdown), `resolution` (for the renderer's
 * resolution dropdown), `width`/`height` (the exact pixel size to render the
 * scene's beauty pass at for this preset), and `value` — the exact fields to
 * spread into that model's generation payload for that preset.
 */
const ENV_GEN_AI_MODELS: Record<string, typeof stagingConfig.GEN_AI_MODELS> = {
  staging: stagingConfig.GEN_AI_MODELS,
  production: productionConfig.GEN_AI_MODELS,
};

// `process` isn't declared in a browser bundle — this file is also imported
// directly by the frontend (see the @kagami/shared/sceneRenderModels vite
// alias) — so APP_ENV can only ever resolve there when Node actually defines
// it, same as config.ts's own doInit().
const env =
  (typeof process !== "undefined" && process.env?.APP_ENV) || "staging";

export const GEN_AI_MODELS =
  ENV_GEN_AI_MODELS[env] ?? stagingConfig.GEN_AI_MODELS;
